import React, { useEffect } from "react";
import FunFact from "../FunFact";
import Hero from "../Hero";
import Div from "../Div";
import SectionHeading from "../SectionHeading";
import Spacing from "../Spacing";
import Cta from "../Cta";
import LogoList from "../LogoList";
import MovingText from "../MovingText";
import PortfolioSlider from "../Slider/PortfolioSlider";
import TeamSlider from "../Slider/TeamSlider";
import VideoModal from "../VideoModal";
import TimelineSlider from "../Slider/TimelineSlider";
import TestimonialSlider from "../Slider/TestimonialSlider";
import { pageTitle } from "../../helper";

export default function Home() {
  pageTitle("Home");

  // Hero Social Links
  const heroSocialLinks = [
    {
      name: "Facebook",
      links: "https://www.facebook.com/HastaLaVista.cse.tmsl?mibextid=ZbWKwL",
    },
    {
      name: "Instagram",
      links: "https://instagram.com/hasta_la_vista.cse?igshid=YmMyMTA2M2Y",
    },
    {
      name: "YouTube",
      links: "https://www.youtube.com/@HastaLaVista_cse",
    },
  ];

  // FunFact Data
  const funfaceData = [
    {
      title: "Students",
      factNumber: "600",
    },
    {
      title: "Team Members",
      factNumber: "50",
    },
    {
      title: "Departments",
      factNumber: "3",
    },
    {
      title: "Event",
      factNumber: "1",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Start Hero Section */}
      <Hero
        title="Hasta <br/>La Vista"
        subtitle="Time to bid farewell to our departing seniors with one last hurrah! Let's party like there's no tomorrow and create some unforgettable memories before they head off to their next adventure!"
        btnText="Know More about us"
        btnLink="/about"
        scrollDownId="#gallery"
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        bgImageUrl="/images/hero_bg.jpeg"
      />
      {/* End Hero Section */}

      {/* Start FunFact Section */}
      <div className="container">
        <FunFact
          variant="cs-type1"
          title="About Team CSE"
          subtitle="A college event requires a dedicated team to be organized and  executed successfully. Behind the scenes of an event, there are several teams working tirelessly to ensure that everything runs smoothly. Our Team CSE is no different as it comprises of multiple teams, which are: the Technical team, the Graphics team, the Cultural team, the PR team, the Sponsorship team, the Finance team, the Decoration team, the Food management team, the External Affairs team, the Photography team and the Event Management team. All the teams come together and join hands to make the event a successful one."
          data={funfaceData}
        />
      </div>
      {/* End FunFact Section */}

      <Spacing lg="150" md="80" />
      <MovingText text="Welcome to Hasta La Vista 2K23" />
      <Spacing lg="20" md="10" />

      {/* Start Service Section */}
      {/* <Div id="service">
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Services we can help you with"
                subtitle="What Can We Do"
                btnText="See All Services"
                btnLink="/service"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-8">
              <Div className="row">
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="UI/UX design"
                    link="/service/service-details"
                    src="/images/service_1.jpeg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="React.js Development"
                    link="/service/service-details"
                    src="/images/service_2.jpeg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Digital Marketing"
                    link="/service/service-details"
                    src="/images/service_3.jpeg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Technology"
                    link="/service/service-details"
                    src="/images/service_4.jpeg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div> */}
      {/* End Service Section */}

      {/* Start Portfolio Section */}
      <Spacing lg="150" md="50" />
      <Div id="gallery">
        <Div className="container">
          <SectionHeading
            title="Some of our Past Glimpses"
            subtitle="Gallery"
            variant="cs-style1 text-center"
          />
          <Spacing lg="90" md="45" />
        </Div>
        <PortfolioSlider />
      </Div>
      {/* End Portfolio Section */}

      {/* Start Awards Section */}
      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_2">
        <Div className="cs-shape_2">
          <Div />
        </Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="What can you expect?"
                subtitle="Fun in our D.N.A"
                variant="cs-style1"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <TimelineSlider />
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Awards Section */}

      {/* Start Video Block Section */}
      <Spacing lg="130" md="70" />
      <Div className="container">
        <h2 className="cs-font_50 cs-m0 text-center cs-line_height_4">
          Check out our teaser video for Hasta La Vista 2023 below to get a
          taste of what to expect!
        </h2>
        <Spacing lg="70" md="70" />
        <VideoModal
          videoSrc="https://www.youtube.com/watch?v=275EpmAOtEE"
          bgUrl="/images/mainLogoW.svg"
        />
      </Div>
      {/* End Video Block Section */}

      {/* Start Team Section */}
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Awesome team <br/>members"
          subtitle="Our Team"
          variant="cs-style1"
        />
        <Spacing lg="85" md="45" />
        <TeamSlider />
      </Div>

      <Spacing lg="150" md="80" />
      {/* End Team Section */}

      {/* Start Testimonial Section */}
      <TestimonialSlider />
      {/* End Testimonial Section */}

      {/* Start Blog Section */}
      {/* <Spacing lg="150" md="80" /> */}
      {/* <Div className="cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Explore recent publication"
                subtitle="Our Blog"
                btnText="View More Blog"
                btnLink="/blog"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <Div className="cs-half_of_full_width">
                <PostSlider />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div> */}
      {/* End Blog Section */}

      {/* Start MovingText Section */}
      <Spacing lg="125" md="70" />
      <MovingText text="Some of our past sponsors" />
      <Spacing lg="105" md="70" />
      {/* End MovingText Section */}

      {/* Start LogoList Section */}
      <Div className="container">
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <script
        id="luma-checkout"
        src="https://embed.lu.ma/checkout-button.js"
      ></script>
      <Div className="container">
        <Cta
          title="Wanna be a part of Hasta La <br />Vista 2K23?"
          btnText="Register for Event"
          btnLink="https://lu.ma/event/evt-xNs3p4DfZd56WHG"
          data-luma-action="checkout"
          data-luma-event-id="evt-xNs3p4DfZd56WHG"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
